import { createFocusTrap, FocusTrap } from 'focus-trap'
import { DirectiveFunction } from 'vue'

/**
 * Directive to trap focus within an element
 * Usage: v-focus-trap="true"
 * DIRECTIVE IS INCOMPATIBLE WITH nodeManager.ts "teleport" FUNCTIONALITY
 * @param {HTMLElement} el - The element to trap focus within
 * @param {boolean} binding.value - Whether to enable the focus trap
 */

let trap: FocusTrap

const createTrap = (el: HTMLElement ) => {
  trap = createFocusTrap(el, {
    initialFocus: false,
  })
}

const destroyTrap = () => {
  trap?.deactivate()
  trap = null
}

const updateTrap: DirectiveFunction = (el, binding) => {
  const shouldSetTrap = binding.value === undefined || binding.value
  if (!trap && shouldSetTrap) {
    const focusTrapElement = (binding.arg ? [el, ...binding.arg] : el) as HTMLElement
    createTrap(focusTrapElement)

    setTimeout(() => {
      trap.activate()
    })
  } else if (trap && !shouldSetTrap) {
    destroyTrap()
  }
}

const focusTrap = {
  inserted: updateTrap,
  update: updateTrap,
  unbind: destroyTrap,
}

export default focusTrap
